import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FeatureFlagService } from '../../../../../shared/services/feature-flag.service';
import { Answer } from '../../../../applicant-service/service-models/Answer';
import { FileUploadQuestion } from '../../../../job-service/service-models/FileUploadQuestion';
import { QuestionComponent } from '../question-component';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent extends QuestionComponent<FileUploadQuestion> implements OnInit {
  fileName: string;
  invalidFile: boolean;
  supportedFileTypes: Array<string> = [
    '.doc', '.docx', '.pdf', '.rtf', '.txt', '.xls', '.xlsx', '.jpg', '.jpeg', '.png', '.gif', '.tif'
  ];
  acceptableFileTypesText: string;
  @ViewChild('fileInput')
  fileInput: ElementRef;
  downloadRoute: string;

  constructor() {
    super();
  }
  
  ngOnInit() {
    this.question = this.question || new FileUploadQuestion();
    this.acceptableFileTypesText = this.supportedFileTypes.join(', ').toUpperCase();

    if (this.question.answers === undefined || this.question.answers.length === 0) {
      this.initialzeAnswers();
    } else {
      const pathParts = this.question.answers[0].value.split('/');
      this.fileName = pathParts[pathParts.length - 1];
      this.question.isValid = true;
    }
    
    this.downloadRoute = `jobs/${this.jobId}/elements/${this.element.id}/questions/${this.question.id}/attachments`;
  }

  fileSelected($event) {
    
    const fileTypeIsNotSupported = !this.isValidFileType($event.srcElement.files[0].name);
    const fileIsTooBig = !this.isValidFileSize($event.srcElement.files[0].size);
    if (fileTypeIsNotSupported || fileIsTooBig) {
      this.invalidFile = true;
      this.question.isValid = false;
      this.questionAnswered();
      return;
    }

    this.invalidFile = false;
    this.question.isValid = true;
    this.question.file = $event.target.files[0];
    this.fileName = this.question.file.name;
    const answer = this.question.answers[0];
    answer.questionId = this.question.id;
    answer.questionVersion = this.question.version;
    answer.value = this.fileName;

    this.questionAnswered();
  }

  removeFile() {
    this.initialzeAnswers();
    this.question.file = null;
    this.question.isValid = false;
    this.invalidFile = false;
    this.fileName = null;
    this.fileInput.nativeElement.value = '';
    this.questionAnswered();
  }

  private initialzeAnswers() {
    this.question.answers = [new Answer()];
    this.question.isValid = false;
  }

  private isValidFileSize(size: number): boolean {
    const maxFileSize = 5242880;
    return maxFileSize >= size;
  }

  private isValidFileType(filename: string): boolean {
    const fileExtension = filename.substring(filename.lastIndexOf('.')).toLocaleLowerCase();
    return this.supportedFileTypes.some(x => x === fileExtension);
  }
}
